module.exports = __webpack_public_path__ + "f7d11036b43cefcd8b89b47147b7c3b9.pdf";